import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { withModulesManager, withHistory } from "@openimis/fe-core";
import HealthFacilityEnrollmentSearcher from "../../components/HealthFacilityEnrollmentSearcher";

const styles = (theme) => ({
  page: theme.page,
});

class HealthFacilityEnrollmentHomePage extends Component {
  onDoubleClick = (enrollment) => {
    if (this.props.history && enrollment?.uuid) {
      this.props.history.push(
        `/enrollment/healthfacility/${enrollment.uuid}/detail`
      );
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.page}>
        <HealthFacilityEnrollmentSearcher
          cacheFiltersKey="enrollmentHealthFacilityPageFiltersCache"
          onDoubleClick={this.onDoubleClick}
        />
      </div>
    );
  }
}

export default injectIntl(
  withModulesManager(
    withHistory(
      withTheme(withStyles(styles)(HealthFacilityEnrollmentHomePage))
    )
  )
);
